const logotext = "";
const meta = {
    title: "Neeraj Laul",
    description: "I’m Neeraj Laul, Engineer, Musician and Coder currently staying in College Park, Maryland",
};

const introdata = {
    title: "I’m Neeraj Laul",
    animated: {
        first: "Engineer.",
        second: "Coding Enthusiast.",
        third: "Musician.",
        fourth: "Video Editor.",
    },
    description: "I am a mechanical engineer learning to code, one project at a time. ",
    your_img_url: "https://i.imgur.com/gQuxqYL.jpeg",
};

const dataabout = {
    title: "A bit about myself:",
    aboutme: "After completing my Mechanical Engineering degree from Savitribai Phule Pune University with a CGPA of 7.82, I began delving into the intricate world of coding. While I was always interested in coding since high school, and even learned a bit of Python and Django in my spare time during engineering, I could only learn it in a structured way after completing my degree. To that end, I completed a course in Python programming and am currently completing an advanced certificate course in Full Stack Development from IIT-Roorkee. Apart from technical skills, I am also an accomplished musician and a video editor. Do check out my band's songs from the YouTube link in the footer!",
};
const worktimeline = [
    {
        jobtitle : "Robotics Engineering",
        where: "University Of Maryland - College Park",
        date: "2024 - 2025",
    },
    {
        jobtitle: "Mechanical Engineering",
        where: "P.E.S. Modern College Of Engineering",
        date: "CGPA:7.82 - First Class With Distinction",

    },
    {
        jobtitle: "Completed 12th ",
        where: "KSJC - HSC",
        date: "69% - First Class",
    },
    {
        jobtitle: "Completed 10th",
        where: "SSRVM - CBSE",
        date: "CGPA: 9.4 - First Class With Distinction",
    },
];

const skills = [
    {
        name: "Python",
        value: 80,
    },
    {
        name: "ROS2",
        value: "60",
    },
    {
        name: "Linux",
        value: "50",
    },
    {
        name: "Solidworks",
        value: "70",
    },
    
    {
        name: "Django",
        value: 70,
    },
    {
        name: "Javascript",
        value: 80,
    },
    {
        name: "React",
        value: 55,
    },
    {
        name: "SpringBoot",
        value: 30,
    },
    {
        name: "AutoCAD",
        value:60,
    },
    {
        name: "ANSYS Spaceclaim",
        value:65,
    },
    {
        name:"ANSYS Workbench - FEA",
        value:50,
    },
    {
        name:"Drums",
        value:90,
    },
    {
        name:"Video Editing",
        value:70,
    },
];

const services = [{
        title: "Freelance Drummer",
        description: "With over 10 years of experience as a percussionist, I can guarantee that my skills will be useful in any recordings or shows that you have. I am able to play the Drums, Cajon, Djembe, Tabla, Dholak, Dholki and Tasha at an advanced level.",
    },
    {
        title: "Web Design",
        description: "My strong foundation of backend principles combined with an innovative and creative approach to frontend design will ensure that the website is always made to your specifications.",
    },
    {
        title: "Video Editing",
        description: "With multiple years of experience working with corporate clients as well as my own band, I can ensure that all of your editing needs are fulfilled within stipulated deadlines. I specialise in music and wedding videos. Do check out the videos I made for my band at the YouTube link in the footer!",
    },
    {
        title: "Mechanical Design",
        description: "As a Mechanical Engineer, I have been exposed to design concepts since the start of my course. My interest in AutoCAD and ANSYS has helped me discover my love for mechanical parts design. The knowledge gained through my degree ensures that I complete any requirements that you might have.",
    },
];

const dataportfolio = [{
    img: "https://i.imgur.com/T29wLod.jpeg",
    description: "Check out my new GitHub page. Stay tuned for more code!",
    link: "https://github.com/NeerajLaul",
    },
    {
        img: "https://i.imgur.com/DG7SJ7R.jpeg",
        description: "Check my band out on YouTube!",
        link: "https://www.youtube.com/@slyverity",
    },
    {
        img: "https://i.imgur.com/BWYTq0I.png",
        description: "My E-portfolio for my Full-Stack course!",
        link: "https://eportfolio.mygreatlearning.com/neeraj-laul",
    },
    {
        img: "https://i.imgur.com/Yvh3LHH.png",
        description: "Check my band out on Spotify!",
        link: "https://open.spotify.com/artist/1FpCAH1NgeqKc8RX43ItES",
    },
    // {
    //     img: "https://picsum.photos/400/300/?grayscale",
    //     description: "The wisdom of life consists in the elimination of non-essentials.",
    //     link: "#",
    // },
    // {
    //     img: "https://picsum.photos/400/?grayscale",
    //     description: "The wisdom of life consists in the elimination of non-essentials.",
    //     link: "#",
    // },
    // {
    //     img: "https://picsum.photos/400/550/?grayscale",
    //     description: "The wisdom of life consists in the elimination of non-essentials.",
    //     link: "#",
    // },
    // {
    //     img: "https://picsum.photos/400/?grayscale",
    //     description: "The wisdom of life consists in the elimination of non-essentials.",
    //     link: "#",
    // },
    // {
    //     img: "https://picsum.photos/400/700/?grayscale",
    //     description: "The wisdom of life consists in the elimination of non-essentials.",
    //     link: "#",
    // },
];

const contactConfig = {
    YOUR_EMAIL: "neeraj.laul@gmail.com",
    YOUR_FONE: "+12403380691",
    description: "Got Questions? Use the form below to get in touch! Alternatively, you can also use my contact details given above. Also, feel free to contact me on Instagram by clicking the Instagram logo in the footer!",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_f9iqajm",
    YOUR_TEMPLATE_ID: "template_vfnpig5",
    YOUR_USER_ID: "lv7PKO0p1mLz826gc",
};

const socialprofils = {
    github: "https://github.com/NeerajLaul",
    facebook: "https://www.facebook.com/laul.neeraj/",
    linkedin: "https://www.linkedin.com/in/neeraj-laul-302468197/",
    instagram: "https://www.instagram.com/neerajlol/",
    youtube: "https://www.youtube.com/@slyverity",

};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
